// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"fe225855","164":"c5e279df","564":"fe225855"}[chunkId] + ".chunk.css";
};